import { c as _c } from "react/compiler-runtime";
import { type PayoutMethod, payoutMethods, type WithdrawalMethod, withdrawalArtwork } from '@morfi/onramp-sdk';
import { useTranslations } from 'next-intl';
import type { ReactNode } from 'react';
import { FundingOptionRow } from '../checkout/funding-method-picker';
export function WithdrawMethodPicker(t0) {
  const $ = _c(31);
  const {
    methods,
    onSelect,
    pending: t1
  } = t0;
  const pending = t1 === undefined ? false : t1;
  const t = useTranslations("onramp");
  let t2;
  if ($[0] !== t) {
    t2 = t("fiat_heading");
    $[0] = t;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t2) {
    t3 = <h3 className="text-micro uppercase text-foreground-secondary">{t2}</h3>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== methods || $[5] !== onSelect || $[6] !== pending || $[7] !== t) {
    t4 = payoutMethods.flatMap(method => methods.some(entry => entry.method === method) ? [<FundingOptionRow key={method} label={t(method)} artwork={`/assets/onramp/method-${withdrawalArtwork[method]}.png`} subtitle={t(method.includes("bank") ? "bank_payout_subtitle" : "payout_account_subtitle")} onSelect={pending ? undefined : () => onSelect(method)} />] : []);
    $[4] = methods;
    $[5] = onSelect;
    $[6] = pending;
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = <div className="overflow-hidden rounded-control bg-background-tertiary">{t4}</div>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t) {
    t6 = t("crypto_heading");
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t6) {
    t7 = <h3 className="text-micro uppercase text-foreground-secondary">{t6}</h3>;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t) {
    t8 = t("manual_withdraw");
    $[15] = t;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t) {
    t9 = t("manual_withdraw_subtitle");
    $[17] = t;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== onSelect || $[20] !== pending) {
    t10 = pending ? undefined : () => onSelect("manual_withdraw");
    $[19] = onSelect;
    $[20] = pending;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t8 || $[24] !== t9) {
    t11 = <div className="rounded-control bg-background-tertiary"><FundingOptionRow label={t8} artwork="/assets/onramp/method-manual-withdraw.png" subtitle={t9} onSelect={t10} /></div>;
    $[22] = t10;
    $[23] = t8;
    $[24] = t9;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t11 || $[27] !== t3 || $[28] !== t5 || $[29] !== t7) {
    t12 = <>{t3}{t5}{t7}{t11}</>;
    $[26] = t11;
    $[27] = t3;
    $[28] = t5;
    $[29] = t7;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  return t12;
}